<template>
    <div
        :class="{
            center: isCentered,
            right: isRightAlign,
            'border-all': isBorderCard,
            'cursor-pointer': isCardLink,
            'column-dynamic': true,
        }"
        @click="goToCardLink"
    >
        <div
            v-if="
                    content.heading &&
                    content.heading[$i18n.locale] &&
                    !headingLink
                "
            :class="{
                'border-all': !isBorderCard && isBorderHeading,
                'border-bottom': isBorderCard && isBorderHeading,
                'd-flex': true,
                'align-center': true,
                'justify-center': true,
                'text-center': true,
            }"
            :style="`background-color: ${headingBackgroundColor}; color: #0063a6; min-height: ${
                $vuetify.breakpoint.mdAndDown ? '70px' : '90px'
            }`"
        >
            <component
                v-if="
                    content.heading &&
                    content.heading[$i18n.locale] &&
                    !headingLink
                "
                :is="headingSize"
                :class="{ uppercase: headingUppercase }"
                >{{ content.heading[$i18n.locale] }}</component
            >
            <CtaLinks
                v-if="headingLink"
                :links="headingLink.links"
                layout="Default"
            />
        </div>
        <div :class="{ 'column--img-square': true }">
            <EmbedSanityImage
                v-if="content.sanityImage && !imageLink"
                :selectedImage="
                    content.sanityImage && content.sanityImage.selectedImage
                "
                classes="mt-0"
                :alt="content.sanityImage && content.sanityImage.alt"
                width="250"
                height="300"
            />
            <CtaLinks
                v-if="imageLink"
                :links="imageLink.links"
                layout="Image"
                :content="content"
            />
        </div>

        <div v-if="content.blurbage && content.blurbage[$i18n.locale]">
            <BlockContent
                :blocks="content.blurbage[$i18n.locale]"
                :serializers="serializers"
            />
        </div>
        <div
            v-if="content.ctaLinks && content.ctaLinks.links"
            :class="{
                'd-flex': true,
                'align-center': true,
                'justify-center': true,
            }"
        >
            <CtaLinks :links="content.ctaLinks.links" />
        </div>
    </div>
</template>
<script>
import CtaLinks from '~/components/CtaLinks.vue'
import serializers from '~/util/sanity/serializers'
import EmbedCloudinary2 from '~/components/embeds/EmbedCloudinary2.vue'
import EmbedSanityImage from '~/components/embeds/EmbedSanityImage.vue'
import setCloudinaryData from '~/util/setCloudinaryData'
import prependRoute from '~/util/prependRoute'
export default {
    name: 'ColumnDynamic',
    components: {
        EmbedCloudinary2,
        EmbedSanityImage,
        CtaLinks,
    },
    props: {
        content: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            serializers,
        }
    },
    computed: {
        headingSize() {
            if (!this.content.headingSize) {
                return 'h3'
            } else {
                return this.content.headingSize
            }
        },
        headingUppercase() {
            return this.content.headingUppercase === true
        },
        isCentered() {
            return this.content.textAlign === 'center'
        },
        isRightAlign() {
            return this.content.textAlign === 'right'
        },
        isBorderCard() {
            return this.content.applyBorderCard
        },
        isBorderHeading() {
            return this.content.applyBorderHeading
        },
        img() {
            return this.image ? setCloudinaryData(this.image, 'column') : {}
        },
        headingBackgroundColor() {
            return this.content?.headingBackgroundColor?.hex
        },
        cardLink() {
            return this.content?.cardLink
        },
        imageLink() {
            return this.content?.imageLink
        },
        headingLink() {
            return this.content?.headingLink
        },
        isCardLink() {
            return this.content?.applyCardLink
        },
    },
    methods: {
        goToCardLink() {
            // THIS NEEDS REFACTOR - ONLY ALLOWS FOR EXTERNAL LINK or INTERNAL LINK
            // console.log(this.cardLink.links)
            if (this.isCardLink) {
                if (this.isExternalLink(this.cardLink.links[0])) {
                    const goto = this.calcHref(this.cardLink.links[0])
                    if (process.browser) {
                        window.open(goto)
                    }
                } else {
                    this.$router.push(this.calcTo(this.cardLink.links[0]))
                }
            }
        },
        isInternalLink(link) {
            // debugger
            return (
                !!link.ctaLinkURL &&
                !link.ctaLinkURLo &&
                !link.ctaLinkTelo &&
                !link.ctaLinkEmailo
            )
        },
        isExternalLink(link) {
            return (
                !!link.ctaLinkURLo && !link.ctaLinkTelo && !link.ctaLinkEmailo
            )
        },
        isPhoneLink(link) {
            return !!link.ctaLinkTelo && !link.ctaLinkEmailo
        },
        isEmailLink(link) {
            return !!link.ctaLinkEmailo
        },
        calcHref(link) {
            const locale = this.$i18n.locale
            if (this.isPhoneLink(link)) {
                return link.ctaLinkTelo ? `tel:+${link.ctaLinkTelo}` : '#'
            }
            if (this.isEmailLink(link)) {
                return link.ctaLinkEmailo ? `mailto:${link.ctaLinkEmailo}` : '#'
            }
            return link.ctaLinkAnchor && link.ctaLinkAnchor[locale]
                ? `${link.ctaLinkURLo}#${link.ctaLinkAnchor[locale]}`
                : link.ctaLinkURLo
        },
        calcTo(link) {
            const locale = this.$i18n.locale
            const type = link.ctaLinkURL ? link.ctaLinkURL._type : 'page'
            const slug = link.ctaLinkURL ? link.ctaLinkURL.slug : '/'
            const calc = prependRoute({ type, slug })
            const partial =
                link.ctaLinkPartial &&
                link.ctaLinkPartial[locale] &&
                link.ctaLinkPartial &&
                link.ctaLinkPartial[locale] !== ''
                    ? `${link.ctaLinkPartial[locale]}/`
                    : ''
            const anchor =
                link.ctaLinkAnchor &&
                link.ctaLinkAnchor[locale] &&
                link.ctaLinkAnchor[locale] !== ''
                    ? `#${link.ctaLinkAnchor[locale]}`
                    : ''
            return calc && calc[locale]
                ? `${calc[locale]}${partial}${anchor}`
                : `#`
        },
    },
}
</script>
